module.exports = __webpack_public_path__ + "img/games-10.935da05f.webp";